// Description: Endpoint to update the profile info
// Updated: 21/08/2025
// Author: Simon Franklin

export async function FinishRegister(infoData) {
    try {
        const token = localStorage.getItem('jwt_token');
        const clientId = localStorage.getItem('idToken');

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!clientId) throw new Error('ID do cliente não encontrado');

        const response = await fetch(`${process.env.REACT_APP_BACKEND_AWS_URL}/profile/info`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    'Client_ID': `${clientId}`
                },
                body: JSON.stringify(infoData)
            }
        );
        
        const data = await response.json();

        return data;
    } catch (error) {
        return error.response.data;
    }
}